import { render, staticRenderFns } from "./LettersEvent.vue?vue&type=template&id=ad6364aa&scoped=true"
import script from "./LettersEvent.vue?vue&type=script&lang=js"
export * from "./LettersEvent.vue?vue&type=script&lang=js"
import style0 from "./LettersEvent.vue?vue&type=style&index=0&id=ad6364aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6364aa",
  null
  
)

export default component.exports